import React, { useRef, useState, useEffect } from 'react'
import { ImagesFiles } from '../ImageFiles/ImageFiles'
import { Button } from 'carbon-components-react'
import {
  CircleSolid,
  SquareFill,
  DirectionStraightRight,
  Draw,
  SettingsEdit,
  RadioButton,
  Checkbox,
  Select_02,
  SelectWindow,
  PaintBrushAlt
} from '@carbon/icons-react'
import {
  CIRCLE,
  EXTRA_SMALL_PEN,
  LARGE_PEN,
  LINE,
  MEDIUM_PEN,
  PEN,
  RECT,
  SELECT,
  SMALL_PEN
} from '../constants'

function KnovaPalette(props) {
  const { getStrokeColor, getStrokeType, getStrokeWidth, isMinimize } = props

  const CANVAS_MODE = {
    PEN: 'PEN',
    SETTINGS: 'SETTINGS',
    REPLAY: 'REPLAY',
    RECORD: 'RECORD',
    SELECT: 'SELECT',
    LABEL: 'LABEL'
  }

  const [strokeWidth, setStrokeWidth] = useState(MEDIUM_PEN)
  const [strokeColor, setStrokeColor] = useState('#000000')
  const [currentMode, setCurrentMode] = useState(CANVAS_MODE.PEN)
  const [sketchType, setSketchType] = useState(PEN)

  useEffect(() => {
    getStrokeColor(strokeColor)
  }, [strokeColor])
  useEffect(() => {
    getStrokeType(sketchType)
  }, [sketchType])
  useEffect(() => {
    getStrokeWidth(strokeWidth)
  }, [strokeWidth])

  function handleExpandFloatingChildWidth(size) {
    if (size === 'xs') {
      document.body.click()
      setStrokeWidth(EXTRA_SMALL_PEN)
    } else if (size === 's') {
      document.body.click()
      setStrokeWidth(SMALL_PEN)
    } else if (size === 'm') {
      document.body.click()
      setStrokeWidth(MEDIUM_PEN)
    } else if (size === 'l') {
      document.body.click()
      setStrokeWidth(LARGE_PEN)
    }
  }

  function renderMainStyleItems() {
    return (
      <div className='main-palette-body'>
        <Button
          className={
            currentMode === CANVAS_MODE.PEN && sketchType === SELECT
              ? 'palette-pen-cont palette-pen-cont-selected'
              : 'palette-pen-cont'
          }
          hasIconOnly
          iconDescription={'Select Stroke'}
          renderIcon={SelectWindow}
          tooltipAlignment='center'
          tooltipPosition='left'
          onClick={() => {
            setCurrentMode(CANVAS_MODE.PEN)
            setSketchType(SELECT)
          }}
        />
        <Button
          className={
            currentMode === CANVAS_MODE.PEN && sketchType === PEN
              ? 'palette-pen-cont palette-pen-cont-selected'
              : 'palette-pen-cont'
          }
          hasIconOnly
          iconDescription={'Free Hand'}
          renderIcon={Draw}
          tooltipAlignment='center'
          tooltipPosition='left'
          onClick={() => {
            setCurrentMode(CANVAS_MODE.PEN)
            setSketchType(PEN)
          }}
        />
        <Button
          className={
            currentMode === CANVAS_MODE.PEN && sketchType === RECT
              ? 'palette-pen-cont palette-pen-cont-selected'
              : 'palette-pen-cont'
          }
          hasIconOnly
          iconDescription={'Square'}
          renderIcon={Checkbox}
          tooltipAlignment='center'
          tooltipPosition='left'
          onClick={() => {
            setCurrentMode(CANVAS_MODE.PEN)
            setSketchType(RECT)
          }}
        />
        <Button
          className={
            currentMode === CANVAS_MODE.PEN && sketchType === CIRCLE
              ? 'palette-pen-cont palette-pen-cont-selected'
              : 'palette-pen-cont'
          }
          hasIconOnly
          iconDescription={'Circle'}
          renderIcon={RadioButton}
          tooltipAlignment='center'
          tooltipPosition='left'
          onClick={() => {
            setCurrentMode(CANVAS_MODE.PEN)
            setSketchType(CIRCLE)
          }}
        />
        <Button
          className={
            currentMode === CANVAS_MODE.PEN && sketchType === LINE
              ? 'palette-pen-cont palette-pen-cont-selected'
              : 'palette-pen-cont'
          }
          hasIconOnly
          iconDescription={'Line'}
          renderIcon={DirectionStraightRight}
          tooltipAlignment='center'
          tooltipPosition='left'
          onClick={() => {
            setCurrentMode(CANVAS_MODE.PEN)
            setSketchType(LINE)
          }}
        />

        <Button
          className={
            currentMode === CANVAS_MODE.SETTINGS
              ? 'palette-pen-cont palette-pen-cont-selected'
              : 'palette-pen-cont'
          }
          hasIconOnly
          iconDescription={'Brush Style'}
          renderIcon={PaintBrushAlt}
          tooltipAlignment='center'
          tooltipPosition='left'
          onClick={() => {
            setCurrentMode(CANVAS_MODE.SETTINGS)
          }}
        />
        {/* <div className='palette-pen-cont'>
          <img
            className='pen-image-style'
            src={
              strokeColor === '#4922fd'
                ? ImagesFiles.stroke_pen_blue
                : strokeColor === '#df3428'
                ? ImagesFiles.stroke_pen_red
                : strokeColor === '#ffc42d'
                ? ImagesFiles.stroke_pen_yellow
                : ImagesFiles.stroke_pen_black
            }
            onClick={() => {
                setCurrentMode(CANVAS_MODE.PEN);
                setCurrentShape(SHAPE_NAME.PEN);
              // if (!isRecording && !isRecordPlaying) {
              //   setSelectedStroke(undefined);
              //   setSelectedLabel(undefined);
              //   setColorPickerType(undefined);
              //   setCurrentMode(CANVAS_MODE.PEN);
              //   setCurrentShape(SHAPE_NAME.PEN);
              //   handleExpandFloatingChildWidth("m");
              // }
            }}
          />
        </div> */}
        {/* <div className='palette-shape-cont'>
          <img
            className='shape-image-style'
            src={ImagesFiles.shape_unselect}
            onClick={() => {}}
          />
        </div>
        <div className='palette-shape-cont'>
          <img
            className='shape-image-style'
            src={ImagesFiles.select_arrow_unselect}
            onClick={() => {}}
          />
        </div> */}
      </div>
    )
  }

  function renderShapeSubItems(params) {}

  function renderPenSubItems() {
    return (
      <div className='pen-sub-cont'>
        {renderWidths()}
        <div className='sub-palette-stroke-color-container'>
          <div
            className={
              strokeColor === '#000000'
                ? 'sub-color-circle-outer sub-color-circle-outer-selected'
                : 'sub-color-circle-outer'
            }
            onClick={() => {
              setStrokeColor('#000000')
            }}
          >
            <div
              className='color-circle'
              style={{ backgroundColor: '#000000' }}
            />
          </div>
          <div
            className={
              strokeColor === '#4922fd'
                ? 'sub-color-circle-outer sub-color-circle-outer-selected'
                : 'sub-color-circle-outer'
            }
            onClick={() => {
              setStrokeColor('#4922fd')
            }}
          >
            <div
              className='color-circle'
              style={{ backgroundColor: '#4922fd' }}
            />
          </div>
          <div
            className={
              strokeColor === '#df3428'
                ? 'sub-color-circle-outer sub-color-circle-outer-selected'
                : 'sub-color-circle-outer'
            }
            onClick={() => {
              setStrokeColor('#df3428')
            }}
          >
            <div
              className='color-circle'
              style={{ backgroundColor: '#df3428' }}
            />
          </div>
          <div
            className={
              strokeColor === '#ffc42d'
                ? 'sub-color-circle-outer sub-color-circle-outer-selected'
                : 'sub-color-circle-outer'
            }
            onClick={() => {
              setStrokeColor('#ffc42d')
            }}
          >
            <div
              className='color-circle'
              style={{ backgroundColor: '#ffc42d' }}
            />
          </div>
        </div>
      </div>
    )
  }

  function renderWidths() {
    return (
      <div className='sub-palette-stroke-size-container'>
        <Button
          className={
            strokeWidth === SMALL_PEN
              ? 'tool-sub-icon tool-sub-icons-1 icons-small tool-sub-icons-1-selected'
              : 'tool-sub-icon tool-sub-icons-1 icons-small'
          }
          hasIconOnly
          iconDescription='Small'
          renderIcon={CircleSolid}
          tooltipAlignment='center'
          tooltipPosition='top'
          onClick={() => {
            handleExpandFloatingChildWidth('s')
          }}
        />
        <Button
          className={
            strokeWidth === MEDIUM_PEN
              ? 'tool-sub-icon tool-sub-icons-1 icons-medium tool-sub-icons-1-selected'
              : 'tool-sub-icon tool-sub-icons-1 icons-medium'
          }
          hasIconOnly
          iconDescription='Medium'
          renderIcon={CircleSolid}
          tooltipAlignment='center'
          tooltipPosition='top'
          onClick={() => {
            handleExpandFloatingChildWidth('m')
          }}
        />
        <Button
          className={
            strokeWidth === LARGE_PEN
              ? 'tool-sub-icon tool-sub-icons-1 tool-sub-icons-1-selected'
              : 'tool-sub-icon tool-sub-icons-1'
          }
          hasIconOnly
          iconDescription='Large'
          renderIcon={CircleSolid}
          tooltipAlignment='center'
          tooltipPosition='top'
          onClick={() => {
            handleExpandFloatingChildWidth('l')
          }}
        />
      </div>
    )
  }

  function renderShapeSubItems() {
    return (
      <div className='pen-sub-cont'>
        {renderWidths()}
        <div className='sub-palette-stroke-size-container'>
          <Button
            className='tool-sub-icon tool-sub-icons-2'
            //   className={
            //     currentShape === SHAPE_NAME.RECT
            //       ? "tool-sub-icon tool-sub-icons-2 tool-sub-icons-2-selected"
            //       : "tool-sub-icon tool-sub-icons-2"
            //   }
            hasIconOnly
            iconDescription='Square'
            renderIcon={SquareFill}
            tooltipAlignment='center'
            tooltipPosition='top'
            onClick={() => {
              //handleFloatingChildPen("square");
            }}
          />
          <Button
            className='tool-sub-icon tool-sub-icons-2'
            //   className={
            //     currentShape === SHAPE_NAME.CIRCLE
            //       ? "tool-sub-icon tool-sub-icons-2 tool-sub-icons-2-selected"
            //       : "tool-sub-icon tool-sub-icons-2"
            //   }
            hasIconOnly
            iconDescription='Circle'
            renderIcon={CircleSolid}
            tooltipAlignment='center'
            tooltipPosition='top'
            onClick={() => {
              // handleFloatingChildPen("circle");
            }}
          />
          <Button
            className='tool-sub-icon tool-sub-icons-2'
            //   className={
            //     currentShape === SHAPE_NAME.LINE
            //       ? "tool-sub-icon tool-sub-icons-2 tool-sub-icons-2-selected"
            //       : "tool-sub-icon tool-sub-icons-2"
            //   }
            hasIconOnly
            iconDescription='Line'
            renderIcon={DirectionStraightRight}
            tooltipAlignment='center'
            tooltipPosition='top'
            onClick={() => {
              // handleFloatingChildPen("line");
            }}
          />
        </div>
      </div>
    )
  }

  function renderSubStyleItems() {
    return (
      <div className='sub-palette-body'>{renderPenSubItems()}</div>
      //   <div className='sub-palette-body'>{renderShapeSubItems()}</div>
    )
  }
  return (
    <div
      className='color-palette-cont'
      style={{ top: isMinimize ? '20px' : '10%' }}
    >
      {currentMode === CANVAS_MODE.SETTINGS && (
        <div className='palette-sub-cont'>{renderSubStyleItems()}</div>
      )}

      <div className='palette-main-cont'>{renderMainStyleItems()}</div>
    </div>
  )
}
export { KnovaPalette }
